import React from 'react';

import { Container, ContainerProps } from '@lglp/components';
import { Footer } from '@lglp/prismic-client';

import { getSingleTypeDocument } from '../../../actions/prismic';
import loading, { withThunk } from '../../../helpers/loading';
import { useSingleType } from '../../../hooks';
import { SSRComponent } from '../../../types/component';
import { DocumentType } from '../../../types/document';
import { ScrollUp } from '../ScrollUp';
import styles from './Footer.module.scss';
import { FooterCards } from './FooterCards';
import { FooterLinks } from './FooterLinks';
import { FooterSocial } from './FooterSocial';

export const FooterComponent: SSRComponent<FooterProps> = ({
  className,
  ...rest
}) => {
  const { data } = useSingleType<Footer>(DocumentType.FOOTER);
  const { cards, menu, socialNetworks } = data || {};
  return (
    <Container
      as="footer"
      role="contentinfo"
      className={[className, styles.container]}
      {...rest}
    >
      <Container className={styles.footer}>
        <FooterCards cards={cards} className={styles.containerCards} />
        <Container className={styles.containerMenu}>
          <FooterLinks menu={menu} className={styles.containerLinks} />
          <FooterSocial
            socialLinks={socialNetworks}
            className={styles.containerSocial}
          />
        </Container>
        <ScrollUp />
      </Container>
    </Container>
  );
};

FooterComponent.getInitialProps = async (serverData: any): Promise<any> =>
  loading(serverData, withThunk(getSingleTypeDocument(DocumentType.FOOTER)));

type FooterProps = ContainerProps;
